import { BannerId, BannerLocation } from 'my-account/constants';
import { ModelBase } from 'store/model-base';

export class BillingBannerInfo extends ModelBase {
    public static storeName: string = 'billingBanner';
    public banners: BillingBanner[];
    public badges: BillingBadge[];

    public get billingBanners(): BillingBanner[] {
        return this.banners.filter((banner: BillingBanner) => banner.location === BannerLocation.BILLING);
    }

    public get btgLineDetailsBanner(): BillingBanner {
        return this.banners.find((banner: BillingBanner) => banner.location === BannerLocation.BTG_LINE_DETAILS);
    }

    public get fourPlusLinePortOutBanner(): BillingBanner[] {
        return this.banners.filter((banner: BillingBanner) => banner.location === BannerLocation.XM_PORTOUT && banner.bannerId === BannerId.CB4_PLUS_LINES_DISCOUNT);
    }
}

